import React, { useState, useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio, Typography } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import config from '../../config/config';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    customTypography: {
      fontFamily: 'FTPolar-Light',
    },
  }));

export default function HomeConcern(props) {
    const classes = useStyles();
    const [salereason, setSalereason] = useState([])
    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    useEffect(() => {
        fetch(`${config.baseUrlCP}get_reason_for_sale/`,
            {
                headers: {
                    "Authorization": `${process.env.REACT_APP_API_KEY}`,
                    'Accept-Encoding': 'gzip, deflate',
                }
            })
            .then(async response => {
                const result = await response.json()
                if (response.status === 201 || response.status === 200) {
                    setSalereason(result)
                }
            }
            );
    }, [])

    return (
        <div className="form-question">
            <div className="form-content" >
                <h4 className="form-content-heading m-0">
                    What’s your biggest concern with selling your home?
                </h4>
                <div className="pt-2 check-box form-content-field">
                    <div className="py-2">
                        <RadioGroup name="property_reason_for_sale_id" value={props.values.property_reason_for_sale_id} onChange={props.handleChange} >
                            {salereason && salereason.map((salereason, index) => (
                                <FormControlLabel
                                    key={salereason.property_reason_for_sale_id}
                                    label={
                                        <Typography
                                          className={props?.partner?.url_path === "c2" ? classes.customTypography : ""}
                                          variant="body1"
                                        >
                                          {salereason.reason_for_sale}
                                        </Typography>
                                    }
                                    control={<StyledRadio />}
                                    value={salereason.property_reason_for_sale_id.toString()}
                                />
                            ))}
                        </RadioGroup>
                    </div>
                    <div className="py-2 row">
                    </div>
                </div>
            </div>
        </div>
    )
}
